import { FuelButton } from '@frete.com/fuel-react';
import React, { FC } from 'react';
import { useHandleStepBack } from './hooks';
import * as Styled from './styled';
import { Props } from './types';

const PageFooter: FC<Props> = ({
  children,
  disableStepsSwitcher,
  isLoading,
}) => {
  const handleStepBack = useHandleStepBack();

  return (
    <Styled.Container>
      {children && <Styled.Content>{children}</Styled.Content>}
      {!disableStepsSwitcher && (
        <Styled.ButtonsBox>
          <FuelButton
            variant="tertiary"
            type="button"
            size="medium"
            onClick={handleStepBack}
          >
            Voltar
          </FuelButton>
          <FuelButton
            variant="primary"
            trailingIcon="arrow-right"
            type="submit"
            size="medium"
            disabled={isLoading}
            isLoading={isLoading}
          >
            Avançar
          </FuelButton>
        </Styled.ButtonsBox>
      )}
    </Styled.Container>
  );
};

export default PageFooter;
